import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconDownload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#9F9F9F",
		d: "M12.667 6.667H10v-4H6v4H3.333L8 11.333l4.667-4.666zm-9.334 6V14h9.334v-1.333H3.333z"
	})
});
export default SvgIconDownload;
